// source: pbtypes/vehicle/infrastructure/flight_deck/status.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var pbtypes_gen_user_camera_user_camera_mode_pb = require('../../../../pbtypes/gen/user_camera/user_camera_mode_pb.js');
goog.object.extend(proto, pbtypes_gen_user_camera_user_camera_mode_pb);
var pbtypes_gen_user_camera_recording_mode_pb = require('../../../../pbtypes/gen/user_camera/recording_mode_pb.js');
goog.object.extend(proto, pbtypes_gen_user_camera_recording_mode_pb);
var pbtypes_gen_cloud_config_client_type_pb = require('../../../../pbtypes/gen/cloud_config/client_type_pb.js');
goog.object.extend(proto, pbtypes_gen_cloud_config_client_type_pb);
var pbtypes_gen_common_flight_phase_enum_pb = require('../../../../pbtypes/gen/common/flight_phase_enum_pb.js');
goog.object.extend(proto, pbtypes_gen_common_flight_phase_enum_pb);
var pbtypes_gen_crypto_encryption_status_pb = require('../../../../pbtypes/gen/crypto/encryption_status_pb.js');
goog.object.extend(proto, pbtypes_gen_crypto_encryption_status_pb);
var pbtypes_gen_flight_deck_feature_flag_enum_pb = require('../../../../pbtypes/gen/flight_deck/feature_flag_enum_pb.js');
goog.object.extend(proto, pbtypes_gen_flight_deck_feature_flag_enum_pb);
var pbtypes_gen_flight_deck_media_mode_pb = require('../../../../pbtypes/gen/flight_deck/media_mode_pb.js');
goog.object.extend(proto, pbtypes_gen_flight_deck_media_mode_pb);
var pbtypes_gen_flight_deck_takeoff_type_pb = require('../../../../pbtypes/gen/flight_deck/takeoff_type_pb.js');
goog.object.extend(proto, pbtypes_gen_flight_deck_takeoff_type_pb);
var pbtypes_gen_phone_app_flavor_pb = require('../../../../pbtypes/gen/phone/app_flavor_pb.js');
goog.object.extend(proto, pbtypes_gen_phone_app_flavor_pb);
var pbtypes_gen_run_modes_run_mode_info_pb = require('../../../../pbtypes/gen/run_modes/run_mode_info_pb.js');
goog.object.extend(proto, pbtypes_gen_run_modes_run_mode_info_pb);
var pbtypes_gen_phone_battery_state_pb = require('../../../../pbtypes/gen/phone/battery_state_pb.js');
goog.object.extend(proto, pbtypes_gen_phone_battery_state_pb);
var pbtypes_gen_phone_display_units_pb = require('../../../../pbtypes/gen/phone/display_units_pb.js');
goog.object.extend(proto, pbtypes_gen_phone_display_units_pb);
var pbtypes_gen_phone_language_preference_pb = require('../../../../pbtypes/gen/phone/language_preference_pb.js');
goog.object.extend(proto, pbtypes_gen_phone_language_preference_pb);
var pbtypes_gen_vehicle_params_for_phone_vehicle_params_pb = require('../../../../pbtypes/gen/vehicle_params_for_phone/vehicle_params_pb.js');
goog.object.extend(proto, pbtypes_gen_vehicle_params_for_phone_vehicle_params_pb);
var pbtypes_gen_video_streaming_stream_settings_pb = require('../../../../pbtypes/gen/video_streaming/stream_settings_pb.js');
goog.object.extend(proto, pbtypes_gen_video_streaming_stream_settings_pb);
var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');
goog.object.extend(proto, google_protobuf_struct_pb);
var pbtypes_vehicle_infrastructure_flight_deck_flight_pb = require('../../../../pbtypes/vehicle/infrastructure/flight_deck/flight_pb.js');
goog.object.extend(proto, pbtypes_vehicle_infrastructure_flight_deck_flight_pb);
var pbtypes_vehicle_infrastructure_flight_deck_runmode_pb = require('../../../../pbtypes/vehicle/infrastructure/flight_deck/runmode_pb.js');
goog.object.extend(proto, pbtypes_vehicle_infrastructure_flight_deck_runmode_pb);
var pbtypes_vehicle_infrastructure_flight_deck_settings_pb = require('../../../../pbtypes/vehicle/infrastructure/flight_deck/settings_pb.js');
goog.object.extend(proto, pbtypes_vehicle_infrastructure_flight_deck_settings_pb);
var pbtypes_vehicle_infrastructure_flight_deck_software_update_pb = require('../../../../pbtypes/vehicle/infrastructure/flight_deck/software_update_pb.js');
goog.object.extend(proto, pbtypes_vehicle_infrastructure_flight_deck_software_update_pb);
goog.exportSymbol('proto.flight_deck.BatteryStatus', null, global);
goog.exportSymbol('proto.flight_deck.ClientStatus', null, global);
goog.exportSymbol('proto.flight_deck.Config', null, global);
goog.exportSymbol('proto.flight_deck.Status', null, global);
goog.exportSymbol('proto.flight_deck.UserCameraStatus', null, global);
goog.exportSymbol('proto.flight_deck.WifiStatus', null, global);
goog.exportSymbol('proto.flight_deck.WifiStatus.SkydioBoardType', null, global);
goog.exportSymbol('proto.flight_deck.WifiStatus.WifiRadioTypeRome', null, global);
goog.exportSymbol('proto.flight_deck.WiredStatus', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.WifiStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.WifiStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.WifiStatus.displayName = 'proto.flight_deck.WifiStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.ClientStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.flight_deck.ClientStatus.repeatedFields_, null);
};
goog.inherits(proto.flight_deck.ClientStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.ClientStatus.displayName = 'proto.flight_deck.ClientStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.BatteryStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.BatteryStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.BatteryStatus.displayName = 'proto.flight_deck.BatteryStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.Status = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.Status, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.Status.displayName = 'proto.flight_deck.Status';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.UserCameraStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.UserCameraStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.UserCameraStatus.displayName = 'proto.flight_deck.UserCameraStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.WiredStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.WiredStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.WiredStatus.displayName = 'proto.flight_deck.WiredStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.Config = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.Config, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.Config.displayName = 'proto.flight_deck.Config';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.WifiStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.WifiStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.WifiStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.WifiStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
boardType: jspb.Message.getFieldWithDefault(msg, 1, 0),
radioType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.WifiStatus}
 */
proto.flight_deck.WifiStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.WifiStatus;
  return proto.flight_deck.WifiStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.WifiStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.WifiStatus}
 */
proto.flight_deck.WifiStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.flight_deck.WifiStatus.SkydioBoardType} */ (reader.readEnum());
      msg.setBoardType(value);
      break;
    case 2:
      var value = /** @type {!proto.flight_deck.WifiStatus.WifiRadioTypeRome} */ (reader.readEnum());
      msg.setRadioType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.WifiStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.WifiStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.WifiStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.WifiStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBoardType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getRadioType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.flight_deck.WifiStatus.SkydioBoardType = {
  SKYDIO_REF_UNDEFINED: 0,
  SKYDIO_REF_R3: 1,
  SKYDIO_REF_E1: 2,
  SKYDIO_REF_R35: 3,
  SKYDIO_REF_BCN: 129,
  SKYDIO_REF_C78: 130
};

/**
 * @enum {number}
 */
proto.flight_deck.WifiStatus.WifiRadioTypeRome = {
  RADIO_DUAL_BAND: 0,
  RADIO_2_4GHZ_ONLY: 1,
  RADIO_5GHZ_ONLY: 5,
  RADIO_UNKNOWN: 255
};

/**
 * optional SkydioBoardType board_type = 1;
 * @return {!proto.flight_deck.WifiStatus.SkydioBoardType}
 */
proto.flight_deck.WifiStatus.prototype.getBoardType = function() {
  return /** @type {!proto.flight_deck.WifiStatus.SkydioBoardType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.flight_deck.WifiStatus.SkydioBoardType} value
 * @return {!proto.flight_deck.WifiStatus} returns this
 */
proto.flight_deck.WifiStatus.prototype.setBoardType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional WifiRadioTypeRome radio_type = 2;
 * @return {!proto.flight_deck.WifiStatus.WifiRadioTypeRome}
 */
proto.flight_deck.WifiStatus.prototype.getRadioType = function() {
  return /** @type {!proto.flight_deck.WifiStatus.WifiRadioTypeRome} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.flight_deck.WifiStatus.WifiRadioTypeRome} value
 * @return {!proto.flight_deck.WifiStatus} returns this
 */
proto.flight_deck.WifiStatus.prototype.setRadioType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.flight_deck.ClientStatus.repeatedFields_ = [11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.ClientStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.ClientStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.ClientStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.ClientStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 16, 0),
sessionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
ipAddress: jspb.Message.getFieldWithDefault(msg, 2, ""),
cloudUserId: jspb.Message.getFieldWithDefault(msg, 10, ""),
rtpPort: jspb.Message.getFieldWithDefault(msg, 3, 0),
mediaMode: jspb.Message.getFieldWithDefault(msg, 4, 0),
wouldAcceptPilot: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
phoneBatteryStatus: (f = msg.getPhoneBatteryStatus()) && proto.flight_deck.BatteryStatus.toObject(includeInstance, f),
takeoffType: jspb.Message.getFieldWithDefault(msg, 7, 0),
recordingMode: jspb.Message.getFieldWithDefault(msg, 8, 0),
inForeground: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
featureFlagsList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
skybusDisabled: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
streamSettings: (f = msg.getStreamSettings()) && pbtypes_gen_video_streaming_stream_settings_pb.StreamSettings.toObject(includeInstance, f),
irStreamSettings: (f = msg.getIrStreamSettings()) && pbtypes_gen_video_streaming_stream_settings_pb.StreamSettings.toObject(includeInstance, f),
clientId: jspb.Message.getFieldWithDefault(msg, 14, ""),
clientType: jspb.Message.getFieldWithDefault(msg, 15, 0),
connectedToDevice: jspb.Message.getFieldWithDefault(msg, 17, ""),
displayUnits: jspb.Message.getFieldWithDefault(msg, 19, 0),
vehicleUserType: jspb.Message.getFieldWithDefault(msg, 20, ""),
appFlavor: jspb.Message.getFieldWithDefault(msg, 21, 0),
languagePreference: jspb.Message.getFieldWithDefault(msg, 22, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.ClientStatus}
 */
proto.flight_deck.ClientStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.ClientStatus;
  return proto.flight_deck.ClientStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.ClientStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.ClientStatus}
 */
proto.flight_deck.ClientStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIpAddress(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCloudUserId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRtpPort(value);
      break;
    case 4:
      var value = /** @type {!proto.flight_deck.MediaMode.Enum} */ (reader.readEnum());
      msg.setMediaMode(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWouldAcceptPilot(value);
      break;
    case 6:
      var value = new proto.flight_deck.BatteryStatus;
      reader.readMessage(value,proto.flight_deck.BatteryStatus.deserializeBinaryFromReader);
      msg.setPhoneBatteryStatus(value);
      break;
    case 7:
      var value = /** @type {!proto.flight_deck.TakeoffType.Enum} */ (reader.readEnum());
      msg.setTakeoffType(value);
      break;
    case 8:
      var value = /** @type {!proto.user_camera.RecordingMode.Enum} */ (reader.readEnum());
      msg.setRecordingMode(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInForeground(value);
      break;
    case 11:
      var values = /** @type {!Array<!proto.flight_deck.FeatureFlagEnum.Enum>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addFeatureFlags(values[i]);
      }
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSkybusDisabled(value);
      break;
    case 13:
      var value = new pbtypes_gen_video_streaming_stream_settings_pb.StreamSettings;
      reader.readMessage(value,pbtypes_gen_video_streaming_stream_settings_pb.StreamSettings.deserializeBinaryFromReader);
      msg.setStreamSettings(value);
      break;
    case 18:
      var value = new pbtypes_gen_video_streaming_stream_settings_pb.StreamSettings;
      reader.readMessage(value,pbtypes_gen_video_streaming_stream_settings_pb.StreamSettings.deserializeBinaryFromReader);
      msg.setIrStreamSettings(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientId(value);
      break;
    case 15:
      var value = /** @type {!proto.cloud_config.ClientType.Enum} */ (reader.readEnum());
      msg.setClientType(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setConnectedToDevice(value);
      break;
    case 19:
      var value = /** @type {!proto.phone.DisplayUnits.Enum} */ (reader.readEnum());
      msg.setDisplayUnits(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setVehicleUserType(value);
      break;
    case 21:
      var value = /** @type {!proto.phone.AppFlavor.Enum} */ (reader.readEnum());
      msg.setAppFlavor(value);
      break;
    case 22:
      var value = /** @type {!proto.phone.LanguagePreference.Enum} */ (reader.readEnum());
      msg.setLanguagePreference(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.ClientStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.ClientStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.ClientStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.ClientStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIpAddress();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCloudUserId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getRtpPort();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getMediaMode();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getWouldAcceptPilot();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getPhoneBatteryStatus();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.flight_deck.BatteryStatus.serializeBinaryToWriter
    );
  }
  f = message.getTakeoffType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getRecordingMode();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getInForeground();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getFeatureFlagsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      11,
      f
    );
  }
  f = message.getSkybusDisabled();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getStreamSettings();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      pbtypes_gen_video_streaming_stream_settings_pb.StreamSettings.serializeBinaryToWriter
    );
  }
  f = message.getIrStreamSettings();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      pbtypes_gen_video_streaming_stream_settings_pb.StreamSettings.serializeBinaryToWriter
    );
  }
  f = message.getClientId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getClientType();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getConnectedToDevice();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getDisplayUnits();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getVehicleUserType();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getAppFlavor();
  if (f !== 0.0) {
    writer.writeEnum(
      21,
      f
    );
  }
  f = message.getLanguagePreference();
  if (f !== 0.0) {
    writer.writeEnum(
      22,
      f
    );
  }
};


/**
 * optional int64 utime = 16;
 * @return {number}
 */
proto.flight_deck.ClientStatus.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.ClientStatus} returns this
 */
proto.flight_deck.ClientStatus.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional string session_id = 1;
 * @return {string}
 */
proto.flight_deck.ClientStatus.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.ClientStatus} returns this
 */
proto.flight_deck.ClientStatus.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ip_address = 2;
 * @return {string}
 */
proto.flight_deck.ClientStatus.prototype.getIpAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.ClientStatus} returns this
 */
proto.flight_deck.ClientStatus.prototype.setIpAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string cloud_user_id = 10;
 * @return {string}
 */
proto.flight_deck.ClientStatus.prototype.getCloudUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.ClientStatus} returns this
 */
proto.flight_deck.ClientStatus.prototype.setCloudUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int32 rtp_port = 3;
 * @return {number}
 */
proto.flight_deck.ClientStatus.prototype.getRtpPort = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.ClientStatus} returns this
 */
proto.flight_deck.ClientStatus.prototype.setRtpPort = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional MediaMode.Enum media_mode = 4;
 * @return {!proto.flight_deck.MediaMode.Enum}
 */
proto.flight_deck.ClientStatus.prototype.getMediaMode = function() {
  return /** @type {!proto.flight_deck.MediaMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.flight_deck.MediaMode.Enum} value
 * @return {!proto.flight_deck.ClientStatus} returns this
 */
proto.flight_deck.ClientStatus.prototype.setMediaMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional bool would_accept_pilot = 5;
 * @return {boolean}
 */
proto.flight_deck.ClientStatus.prototype.getWouldAcceptPilot = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.ClientStatus} returns this
 */
proto.flight_deck.ClientStatus.prototype.setWouldAcceptPilot = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional BatteryStatus phone_battery_status = 6;
 * @return {?proto.flight_deck.BatteryStatus}
 */
proto.flight_deck.ClientStatus.prototype.getPhoneBatteryStatus = function() {
  return /** @type{?proto.flight_deck.BatteryStatus} */ (
    jspb.Message.getWrapperField(this, proto.flight_deck.BatteryStatus, 6));
};


/**
 * @param {?proto.flight_deck.BatteryStatus|undefined} value
 * @return {!proto.flight_deck.ClientStatus} returns this
*/
proto.flight_deck.ClientStatus.prototype.setPhoneBatteryStatus = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.ClientStatus} returns this
 */
proto.flight_deck.ClientStatus.prototype.clearPhoneBatteryStatus = function() {
  return this.setPhoneBatteryStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.ClientStatus.prototype.hasPhoneBatteryStatus = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional TakeoffType.Enum takeoff_type = 7;
 * @return {!proto.flight_deck.TakeoffType.Enum}
 */
proto.flight_deck.ClientStatus.prototype.getTakeoffType = function() {
  return /** @type {!proto.flight_deck.TakeoffType.Enum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.flight_deck.TakeoffType.Enum} value
 * @return {!proto.flight_deck.ClientStatus} returns this
 */
proto.flight_deck.ClientStatus.prototype.setTakeoffType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional user_camera.RecordingMode.Enum recording_mode = 8;
 * @return {!proto.user_camera.RecordingMode.Enum}
 */
proto.flight_deck.ClientStatus.prototype.getRecordingMode = function() {
  return /** @type {!proto.user_camera.RecordingMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.user_camera.RecordingMode.Enum} value
 * @return {!proto.flight_deck.ClientStatus} returns this
 */
proto.flight_deck.ClientStatus.prototype.setRecordingMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional bool in_foreground = 9;
 * @return {boolean}
 */
proto.flight_deck.ClientStatus.prototype.getInForeground = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.ClientStatus} returns this
 */
proto.flight_deck.ClientStatus.prototype.setInForeground = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * repeated FeatureFlagEnum.Enum feature_flags = 11;
 * @return {!Array<!proto.flight_deck.FeatureFlagEnum.Enum>}
 */
proto.flight_deck.ClientStatus.prototype.getFeatureFlagsList = function() {
  return /** @type {!Array<!proto.flight_deck.FeatureFlagEnum.Enum>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<!proto.flight_deck.FeatureFlagEnum.Enum>} value
 * @return {!proto.flight_deck.ClientStatus} returns this
 */
proto.flight_deck.ClientStatus.prototype.setFeatureFlagsList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {!proto.flight_deck.FeatureFlagEnum.Enum} value
 * @param {number=} opt_index
 * @return {!proto.flight_deck.ClientStatus} returns this
 */
proto.flight_deck.ClientStatus.prototype.addFeatureFlags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flight_deck.ClientStatus} returns this
 */
proto.flight_deck.ClientStatus.prototype.clearFeatureFlagsList = function() {
  return this.setFeatureFlagsList([]);
};


/**
 * optional bool skybus_disabled = 12;
 * @return {boolean}
 */
proto.flight_deck.ClientStatus.prototype.getSkybusDisabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.ClientStatus} returns this
 */
proto.flight_deck.ClientStatus.prototype.setSkybusDisabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional video_streaming.StreamSettings stream_settings = 13;
 * @return {?proto.video_streaming.StreamSettings}
 */
proto.flight_deck.ClientStatus.prototype.getStreamSettings = function() {
  return /** @type{?proto.video_streaming.StreamSettings} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_video_streaming_stream_settings_pb.StreamSettings, 13));
};


/**
 * @param {?proto.video_streaming.StreamSettings|undefined} value
 * @return {!proto.flight_deck.ClientStatus} returns this
*/
proto.flight_deck.ClientStatus.prototype.setStreamSettings = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.ClientStatus} returns this
 */
proto.flight_deck.ClientStatus.prototype.clearStreamSettings = function() {
  return this.setStreamSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.ClientStatus.prototype.hasStreamSettings = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional video_streaming.StreamSettings ir_stream_settings = 18;
 * @return {?proto.video_streaming.StreamSettings}
 */
proto.flight_deck.ClientStatus.prototype.getIrStreamSettings = function() {
  return /** @type{?proto.video_streaming.StreamSettings} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_video_streaming_stream_settings_pb.StreamSettings, 18));
};


/**
 * @param {?proto.video_streaming.StreamSettings|undefined} value
 * @return {!proto.flight_deck.ClientStatus} returns this
*/
proto.flight_deck.ClientStatus.prototype.setIrStreamSettings = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.ClientStatus} returns this
 */
proto.flight_deck.ClientStatus.prototype.clearIrStreamSettings = function() {
  return this.setIrStreamSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.ClientStatus.prototype.hasIrStreamSettings = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional string client_id = 14;
 * @return {string}
 */
proto.flight_deck.ClientStatus.prototype.getClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.ClientStatus} returns this
 */
proto.flight_deck.ClientStatus.prototype.setClientId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional cloud_config.ClientType.Enum client_type = 15;
 * @return {!proto.cloud_config.ClientType.Enum}
 */
proto.flight_deck.ClientStatus.prototype.getClientType = function() {
  return /** @type {!proto.cloud_config.ClientType.Enum} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.cloud_config.ClientType.Enum} value
 * @return {!proto.flight_deck.ClientStatus} returns this
 */
proto.flight_deck.ClientStatus.prototype.setClientType = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional string connected_to_device = 17;
 * @return {string}
 */
proto.flight_deck.ClientStatus.prototype.getConnectedToDevice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.ClientStatus} returns this
 */
proto.flight_deck.ClientStatus.prototype.setConnectedToDevice = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional phone.DisplayUnits.Enum display_units = 19;
 * @return {!proto.phone.DisplayUnits.Enum}
 */
proto.flight_deck.ClientStatus.prototype.getDisplayUnits = function() {
  return /** @type {!proto.phone.DisplayUnits.Enum} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.phone.DisplayUnits.Enum} value
 * @return {!proto.flight_deck.ClientStatus} returns this
 */
proto.flight_deck.ClientStatus.prototype.setDisplayUnits = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional string vehicle_user_type = 20;
 * @return {string}
 */
proto.flight_deck.ClientStatus.prototype.getVehicleUserType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.ClientStatus} returns this
 */
proto.flight_deck.ClientStatus.prototype.setVehicleUserType = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional phone.AppFlavor.Enum app_flavor = 21;
 * @return {!proto.phone.AppFlavor.Enum}
 */
proto.flight_deck.ClientStatus.prototype.getAppFlavor = function() {
  return /** @type {!proto.phone.AppFlavor.Enum} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {!proto.phone.AppFlavor.Enum} value
 * @return {!proto.flight_deck.ClientStatus} returns this
 */
proto.flight_deck.ClientStatus.prototype.setAppFlavor = function(value) {
  return jspb.Message.setProto3EnumField(this, 21, value);
};


/**
 * optional phone.LanguagePreference.Enum language_preference = 22;
 * @return {!proto.phone.LanguagePreference.Enum}
 */
proto.flight_deck.ClientStatus.prototype.getLanguagePreference = function() {
  return /** @type {!proto.phone.LanguagePreference.Enum} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {!proto.phone.LanguagePreference.Enum} value
 * @return {!proto.flight_deck.ClientStatus} returns this
 */
proto.flight_deck.ClientStatus.prototype.setLanguagePreference = function(value) {
  return jspb.Message.setProto3EnumField(this, 22, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.BatteryStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.BatteryStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.BatteryStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.BatteryStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
percent: jspb.Message.getFieldWithDefault(msg, 1, 0),
state: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.BatteryStatus}
 */
proto.flight_deck.BatteryStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.BatteryStatus;
  return proto.flight_deck.BatteryStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.BatteryStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.BatteryStatus}
 */
proto.flight_deck.BatteryStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPercent(value);
      break;
    case 2:
      var value = /** @type {!proto.phone.BatteryState.Enum} */ (reader.readEnum());
      msg.setState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.BatteryStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.BatteryStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.BatteryStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.BatteryStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPercent();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional int32 percent = 1;
 * @return {number}
 */
proto.flight_deck.BatteryStatus.prototype.getPercent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.BatteryStatus} returns this
 */
proto.flight_deck.BatteryStatus.prototype.setPercent = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional phone.BatteryState.Enum state = 2;
 * @return {!proto.phone.BatteryState.Enum}
 */
proto.flight_deck.BatteryStatus.prototype.getState = function() {
  return /** @type {!proto.phone.BatteryState.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.phone.BatteryState.Enum} value
 * @return {!proto.flight_deck.BatteryStatus} returns this
 */
proto.flight_deck.BatteryStatus.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.Status.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.Status.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.Status} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.Status.toObject = function(includeInstance, msg) {
  var f, obj = {
sessionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
batteryVersion: jspb.Message.getFieldWithDefault(msg, 45, 0),
batteryPercent: jspb.Message.getFieldWithDefault(msg, 2, 0),
batteryVoltage: jspb.Message.getFloatingPointFieldWithDefault(msg, 17, 0.0),
batteryCharging: jspb.Message.getBooleanFieldWithDefault(msg, 32, false),
batteryCurrent: jspb.Message.getFloatingPointFieldWithDefault(msg, 34, 0.0),
batteryTemperature: jspb.Message.getFloatingPointFieldWithDefault(msg, 35, 0.0),
chargerVersion: jspb.Message.getFieldWithDefault(msg, 46, 0),
returnBatteryPercent: jspb.Message.getFieldWithDefault(msg, 37, 0),
landBatteryPercent: jspb.Message.getFieldWithDefault(msg, 38, 0),
runModeStatus: jspb.Message.getFieldWithDefault(msg, 3, 0),
config: (f = msg.getConfig()) && proto.flight_deck.Config.toObject(includeInstance, f),
lastCalibDate: jspb.Message.getFieldWithDefault(msg, 18, ""),
runModeName: jspb.Message.getFieldWithDefault(msg, 20, ""),
currentRunModeInfo: (f = msg.getCurrentRunModeInfo()) && pbtypes_gen_run_modes_run_mode_info_pb.RunModeInfo.toObject(includeInstance, f),
vehicleType: jspb.Message.getFieldWithDefault(msg, 21, ""),
isGimbaled: jspb.Message.getBooleanFieldWithDefault(msg, 22, false),
activeFlight: (f = msg.getActiveFlight()) && pbtypes_vehicle_infrastructure_flight_deck_flight_pb.Flight.toObject(includeInstance, f),
previousFlight: (f = msg.getPreviousFlight()) && pbtypes_vehicle_infrastructure_flight_deck_flight_pb.Flight.toObject(includeInstance, f),
flightPhase: jspb.Message.getFieldWithDefault(msg, 25, 0),
userCameraStatus: (f = msg.getUserCameraStatus()) && proto.flight_deck.UserCameraStatus.toObject(includeInstance, f),
softwareUpdateStatus: (f = msg.getSoftwareUpdateStatus()) && pbtypes_vehicle_infrastructure_flight_deck_software_update_pb.SoftwareUpdateStatus.toObject(includeInstance, f),
pilotLastAccessUtime: jspb.Message.getFieldWithDefault(msg, 29, 0),
skillKey: jspb.Message.getFieldWithDefault(msg, 30, ""),
allSettings: (f = msg.getAllSettings()) && pbtypes_vehicle_infrastructure_flight_deck_settings_pb.AllSettings.toObject(includeInstance, f),
wiredStatus: (f = msg.getWiredStatus()) && proto.flight_deck.WiredStatus.toObject(includeInstance, f),
encryptionStatus: jspb.Message.getFieldWithDefault(msg, 36, 0),
cloudConfigLastUpdated: jspb.Message.getFieldWithDefault(msg, 40, 0),
runId: jspb.Message.getFieldWithDefault(msg, 42, ""),
bootId: jspb.Message.getFieldWithDefault(msg, 43, ""),
wifiStatus: (f = msg.getWifiStatus()) && proto.flight_deck.WifiStatus.toObject(includeInstance, f),
ridBcast: jspb.Message.getBooleanFieldWithDefault(msg, 47, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.Status}
 */
proto.flight_deck.Status.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.Status;
  return proto.flight_deck.Status.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.Status} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.Status}
 */
proto.flight_deck.Status.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionId(value);
      break;
    case 45:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBatteryVersion(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBatteryPercent(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setBatteryVoltage(value);
      break;
    case 32:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBatteryCharging(value);
      break;
    case 34:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setBatteryCurrent(value);
      break;
    case 35:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setBatteryTemperature(value);
      break;
    case 46:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setChargerVersion(value);
      break;
    case 37:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setReturnBatteryPercent(value);
      break;
    case 38:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLandBatteryPercent(value);
      break;
    case 3:
      var value = /** @type {!proto.flight_deck.RunModeStatus} */ (reader.readEnum());
      msg.setRunModeStatus(value);
      break;
    case 16:
      var value = new proto.flight_deck.Config;
      reader.readMessage(value,proto.flight_deck.Config.deserializeBinaryFromReader);
      msg.setConfig(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastCalibDate(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setRunModeName(value);
      break;
    case 39:
      var value = new pbtypes_gen_run_modes_run_mode_info_pb.RunModeInfo;
      reader.readMessage(value,pbtypes_gen_run_modes_run_mode_info_pb.RunModeInfo.deserializeBinaryFromReader);
      msg.setCurrentRunModeInfo(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setVehicleType(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsGimbaled(value);
      break;
    case 23:
      var value = new pbtypes_vehicle_infrastructure_flight_deck_flight_pb.Flight;
      reader.readMessage(value,pbtypes_vehicle_infrastructure_flight_deck_flight_pb.Flight.deserializeBinaryFromReader);
      msg.setActiveFlight(value);
      break;
    case 24:
      var value = new pbtypes_vehicle_infrastructure_flight_deck_flight_pb.Flight;
      reader.readMessage(value,pbtypes_vehicle_infrastructure_flight_deck_flight_pb.Flight.deserializeBinaryFromReader);
      msg.setPreviousFlight(value);
      break;
    case 25:
      var value = /** @type {!proto.common.FlightPhaseEnum.Enum} */ (reader.readEnum());
      msg.setFlightPhase(value);
      break;
    case 28:
      var value = new proto.flight_deck.UserCameraStatus;
      reader.readMessage(value,proto.flight_deck.UserCameraStatus.deserializeBinaryFromReader);
      msg.setUserCameraStatus(value);
      break;
    case 41:
      var value = new pbtypes_vehicle_infrastructure_flight_deck_software_update_pb.SoftwareUpdateStatus;
      reader.readMessage(value,pbtypes_vehicle_infrastructure_flight_deck_software_update_pb.SoftwareUpdateStatus.deserializeBinaryFromReader);
      msg.setSoftwareUpdateStatus(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPilotLastAccessUtime(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setSkillKey(value);
      break;
    case 31:
      var value = new pbtypes_vehicle_infrastructure_flight_deck_settings_pb.AllSettings;
      reader.readMessage(value,pbtypes_vehicle_infrastructure_flight_deck_settings_pb.AllSettings.deserializeBinaryFromReader);
      msg.setAllSettings(value);
      break;
    case 33:
      var value = new proto.flight_deck.WiredStatus;
      reader.readMessage(value,proto.flight_deck.WiredStatus.deserializeBinaryFromReader);
      msg.setWiredStatus(value);
      break;
    case 36:
      var value = /** @type {!proto.crypto.EncryptionStatus.Enum} */ (reader.readEnum());
      msg.setEncryptionStatus(value);
      break;
    case 40:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCloudConfigLastUpdated(value);
      break;
    case 42:
      var value = /** @type {string} */ (reader.readString());
      msg.setRunId(value);
      break;
    case 43:
      var value = /** @type {string} */ (reader.readString());
      msg.setBootId(value);
      break;
    case 44:
      var value = new proto.flight_deck.WifiStatus;
      reader.readMessage(value,proto.flight_deck.WifiStatus.deserializeBinaryFromReader);
      msg.setWifiStatus(value);
      break;
    case 47:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRidBcast(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.Status.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.Status.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.Status} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.Status.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBatteryVersion();
  if (f !== 0) {
    writer.writeInt32(
      45,
      f
    );
  }
  f = message.getBatteryPercent();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getBatteryVoltage();
  if (f !== 0.0) {
    writer.writeFloat(
      17,
      f
    );
  }
  f = message.getBatteryCharging();
  if (f) {
    writer.writeBool(
      32,
      f
    );
  }
  f = message.getBatteryCurrent();
  if (f !== 0.0) {
    writer.writeFloat(
      34,
      f
    );
  }
  f = message.getBatteryTemperature();
  if (f !== 0.0) {
    writer.writeFloat(
      35,
      f
    );
  }
  f = message.getChargerVersion();
  if (f !== 0) {
    writer.writeInt32(
      46,
      f
    );
  }
  f = message.getReturnBatteryPercent();
  if (f !== 0) {
    writer.writeInt32(
      37,
      f
    );
  }
  f = message.getLandBatteryPercent();
  if (f !== 0) {
    writer.writeInt32(
      38,
      f
    );
  }
  f = message.getRunModeStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getConfig();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.flight_deck.Config.serializeBinaryToWriter
    );
  }
  f = message.getLastCalibDate();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getRunModeName();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getCurrentRunModeInfo();
  if (f != null) {
    writer.writeMessage(
      39,
      f,
      pbtypes_gen_run_modes_run_mode_info_pb.RunModeInfo.serializeBinaryToWriter
    );
  }
  f = message.getVehicleType();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getIsGimbaled();
  if (f) {
    writer.writeBool(
      22,
      f
    );
  }
  f = message.getActiveFlight();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      pbtypes_vehicle_infrastructure_flight_deck_flight_pb.Flight.serializeBinaryToWriter
    );
  }
  f = message.getPreviousFlight();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      pbtypes_vehicle_infrastructure_flight_deck_flight_pb.Flight.serializeBinaryToWriter
    );
  }
  f = message.getFlightPhase();
  if (f !== 0.0) {
    writer.writeEnum(
      25,
      f
    );
  }
  f = message.getUserCameraStatus();
  if (f != null) {
    writer.writeMessage(
      28,
      f,
      proto.flight_deck.UserCameraStatus.serializeBinaryToWriter
    );
  }
  f = message.getSoftwareUpdateStatus();
  if (f != null) {
    writer.writeMessage(
      41,
      f,
      pbtypes_vehicle_infrastructure_flight_deck_software_update_pb.SoftwareUpdateStatus.serializeBinaryToWriter
    );
  }
  f = message.getPilotLastAccessUtime();
  if (f !== 0) {
    writer.writeInt64(
      29,
      f
    );
  }
  f = message.getSkillKey();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getAllSettings();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      pbtypes_vehicle_infrastructure_flight_deck_settings_pb.AllSettings.serializeBinaryToWriter
    );
  }
  f = message.getWiredStatus();
  if (f != null) {
    writer.writeMessage(
      33,
      f,
      proto.flight_deck.WiredStatus.serializeBinaryToWriter
    );
  }
  f = message.getEncryptionStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      36,
      f
    );
  }
  f = message.getCloudConfigLastUpdated();
  if (f !== 0) {
    writer.writeInt64(
      40,
      f
    );
  }
  f = message.getRunId();
  if (f.length > 0) {
    writer.writeString(
      42,
      f
    );
  }
  f = message.getBootId();
  if (f.length > 0) {
    writer.writeString(
      43,
      f
    );
  }
  f = message.getWifiStatus();
  if (f != null) {
    writer.writeMessage(
      44,
      f,
      proto.flight_deck.WifiStatus.serializeBinaryToWriter
    );
  }
  f = message.getRidBcast();
  if (f) {
    writer.writeBool(
      47,
      f
    );
  }
};


/**
 * optional string session_id = 1;
 * @return {string}
 */
proto.flight_deck.Status.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 battery_version = 45;
 * @return {number}
 */
proto.flight_deck.Status.prototype.getBatteryVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 45, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.setBatteryVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 45, value);
};


/**
 * optional int32 battery_percent = 2;
 * @return {number}
 */
proto.flight_deck.Status.prototype.getBatteryPercent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.setBatteryPercent = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional float battery_voltage = 17;
 * @return {number}
 */
proto.flight_deck.Status.prototype.getBatteryVoltage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.setBatteryVoltage = function(value) {
  return jspb.Message.setProto3FloatField(this, 17, value);
};


/**
 * optional bool battery_charging = 32;
 * @return {boolean}
 */
proto.flight_deck.Status.prototype.getBatteryCharging = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 32, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.setBatteryCharging = function(value) {
  return jspb.Message.setProto3BooleanField(this, 32, value);
};


/**
 * optional float battery_current = 34;
 * @return {number}
 */
proto.flight_deck.Status.prototype.getBatteryCurrent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 34, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.setBatteryCurrent = function(value) {
  return jspb.Message.setProto3FloatField(this, 34, value);
};


/**
 * optional float battery_temperature = 35;
 * @return {number}
 */
proto.flight_deck.Status.prototype.getBatteryTemperature = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 35, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.setBatteryTemperature = function(value) {
  return jspb.Message.setProto3FloatField(this, 35, value);
};


/**
 * optional int32 charger_version = 46;
 * @return {number}
 */
proto.flight_deck.Status.prototype.getChargerVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 46, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.setChargerVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 46, value);
};


/**
 * optional int32 return_battery_percent = 37;
 * @return {number}
 */
proto.flight_deck.Status.prototype.getReturnBatteryPercent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 37, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.setReturnBatteryPercent = function(value) {
  return jspb.Message.setProto3IntField(this, 37, value);
};


/**
 * optional int32 land_battery_percent = 38;
 * @return {number}
 */
proto.flight_deck.Status.prototype.getLandBatteryPercent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 38, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.setLandBatteryPercent = function(value) {
  return jspb.Message.setProto3IntField(this, 38, value);
};


/**
 * optional RunModeStatus run_mode_status = 3;
 * @return {!proto.flight_deck.RunModeStatus}
 */
proto.flight_deck.Status.prototype.getRunModeStatus = function() {
  return /** @type {!proto.flight_deck.RunModeStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.flight_deck.RunModeStatus} value
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.setRunModeStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional Config config = 16;
 * @return {?proto.flight_deck.Config}
 */
proto.flight_deck.Status.prototype.getConfig = function() {
  return /** @type{?proto.flight_deck.Config} */ (
    jspb.Message.getWrapperField(this, proto.flight_deck.Config, 16));
};


/**
 * @param {?proto.flight_deck.Config|undefined} value
 * @return {!proto.flight_deck.Status} returns this
*/
proto.flight_deck.Status.prototype.setConfig = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.clearConfig = function() {
  return this.setConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.Status.prototype.hasConfig = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional string last_calib_date = 18;
 * @return {string}
 */
proto.flight_deck.Status.prototype.getLastCalibDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.setLastCalibDate = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string run_mode_name = 20;
 * @return {string}
 */
proto.flight_deck.Status.prototype.getRunModeName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.setRunModeName = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional run_modes.RunModeInfo current_run_mode_info = 39;
 * @return {?proto.run_modes.RunModeInfo}
 */
proto.flight_deck.Status.prototype.getCurrentRunModeInfo = function() {
  return /** @type{?proto.run_modes.RunModeInfo} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_run_modes_run_mode_info_pb.RunModeInfo, 39));
};


/**
 * @param {?proto.run_modes.RunModeInfo|undefined} value
 * @return {!proto.flight_deck.Status} returns this
*/
proto.flight_deck.Status.prototype.setCurrentRunModeInfo = function(value) {
  return jspb.Message.setWrapperField(this, 39, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.clearCurrentRunModeInfo = function() {
  return this.setCurrentRunModeInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.Status.prototype.hasCurrentRunModeInfo = function() {
  return jspb.Message.getField(this, 39) != null;
};


/**
 * optional string vehicle_type = 21;
 * @return {string}
 */
proto.flight_deck.Status.prototype.getVehicleType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.setVehicleType = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional bool is_gimbaled = 22;
 * @return {boolean}
 */
proto.flight_deck.Status.prototype.getIsGimbaled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 22, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.setIsGimbaled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 22, value);
};


/**
 * optional Flight active_flight = 23;
 * @return {?proto.flight_deck.Flight}
 */
proto.flight_deck.Status.prototype.getActiveFlight = function() {
  return /** @type{?proto.flight_deck.Flight} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_infrastructure_flight_deck_flight_pb.Flight, 23));
};


/**
 * @param {?proto.flight_deck.Flight|undefined} value
 * @return {!proto.flight_deck.Status} returns this
*/
proto.flight_deck.Status.prototype.setActiveFlight = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.clearActiveFlight = function() {
  return this.setActiveFlight(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.Status.prototype.hasActiveFlight = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional Flight previous_flight = 24;
 * @return {?proto.flight_deck.Flight}
 */
proto.flight_deck.Status.prototype.getPreviousFlight = function() {
  return /** @type{?proto.flight_deck.Flight} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_infrastructure_flight_deck_flight_pb.Flight, 24));
};


/**
 * @param {?proto.flight_deck.Flight|undefined} value
 * @return {!proto.flight_deck.Status} returns this
*/
proto.flight_deck.Status.prototype.setPreviousFlight = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.clearPreviousFlight = function() {
  return this.setPreviousFlight(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.Status.prototype.hasPreviousFlight = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional common.FlightPhaseEnum.Enum flight_phase = 25;
 * @return {!proto.common.FlightPhaseEnum.Enum}
 */
proto.flight_deck.Status.prototype.getFlightPhase = function() {
  return /** @type {!proto.common.FlightPhaseEnum.Enum} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {!proto.common.FlightPhaseEnum.Enum} value
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.setFlightPhase = function(value) {
  return jspb.Message.setProto3EnumField(this, 25, value);
};


/**
 * optional UserCameraStatus user_camera_status = 28;
 * @return {?proto.flight_deck.UserCameraStatus}
 */
proto.flight_deck.Status.prototype.getUserCameraStatus = function() {
  return /** @type{?proto.flight_deck.UserCameraStatus} */ (
    jspb.Message.getWrapperField(this, proto.flight_deck.UserCameraStatus, 28));
};


/**
 * @param {?proto.flight_deck.UserCameraStatus|undefined} value
 * @return {!proto.flight_deck.Status} returns this
*/
proto.flight_deck.Status.prototype.setUserCameraStatus = function(value) {
  return jspb.Message.setWrapperField(this, 28, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.clearUserCameraStatus = function() {
  return this.setUserCameraStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.Status.prototype.hasUserCameraStatus = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional SoftwareUpdateStatus software_update_status = 41;
 * @return {?proto.flight_deck.SoftwareUpdateStatus}
 */
proto.flight_deck.Status.prototype.getSoftwareUpdateStatus = function() {
  return /** @type{?proto.flight_deck.SoftwareUpdateStatus} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_infrastructure_flight_deck_software_update_pb.SoftwareUpdateStatus, 41));
};


/**
 * @param {?proto.flight_deck.SoftwareUpdateStatus|undefined} value
 * @return {!proto.flight_deck.Status} returns this
*/
proto.flight_deck.Status.prototype.setSoftwareUpdateStatus = function(value) {
  return jspb.Message.setWrapperField(this, 41, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.clearSoftwareUpdateStatus = function() {
  return this.setSoftwareUpdateStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.Status.prototype.hasSoftwareUpdateStatus = function() {
  return jspb.Message.getField(this, 41) != null;
};


/**
 * optional int64 pilot_last_access_utime = 29;
 * @return {number}
 */
proto.flight_deck.Status.prototype.getPilotLastAccessUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.setPilotLastAccessUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 29, value);
};


/**
 * optional string skill_key = 30;
 * @return {string}
 */
proto.flight_deck.Status.prototype.getSkillKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.setSkillKey = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional AllSettings all_settings = 31;
 * @return {?proto.flight_deck.AllSettings}
 */
proto.flight_deck.Status.prototype.getAllSettings = function() {
  return /** @type{?proto.flight_deck.AllSettings} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_infrastructure_flight_deck_settings_pb.AllSettings, 31));
};


/**
 * @param {?proto.flight_deck.AllSettings|undefined} value
 * @return {!proto.flight_deck.Status} returns this
*/
proto.flight_deck.Status.prototype.setAllSettings = function(value) {
  return jspb.Message.setWrapperField(this, 31, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.clearAllSettings = function() {
  return this.setAllSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.Status.prototype.hasAllSettings = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional WiredStatus wired_status = 33;
 * @return {?proto.flight_deck.WiredStatus}
 */
proto.flight_deck.Status.prototype.getWiredStatus = function() {
  return /** @type{?proto.flight_deck.WiredStatus} */ (
    jspb.Message.getWrapperField(this, proto.flight_deck.WiredStatus, 33));
};


/**
 * @param {?proto.flight_deck.WiredStatus|undefined} value
 * @return {!proto.flight_deck.Status} returns this
*/
proto.flight_deck.Status.prototype.setWiredStatus = function(value) {
  return jspb.Message.setWrapperField(this, 33, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.clearWiredStatus = function() {
  return this.setWiredStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.Status.prototype.hasWiredStatus = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional crypto.EncryptionStatus.Enum encryption_status = 36;
 * @return {!proto.crypto.EncryptionStatus.Enum}
 */
proto.flight_deck.Status.prototype.getEncryptionStatus = function() {
  return /** @type {!proto.crypto.EncryptionStatus.Enum} */ (jspb.Message.getFieldWithDefault(this, 36, 0));
};


/**
 * @param {!proto.crypto.EncryptionStatus.Enum} value
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.setEncryptionStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 36, value);
};


/**
 * optional int64 cloud_config_last_updated = 40;
 * @return {number}
 */
proto.flight_deck.Status.prototype.getCloudConfigLastUpdated = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 40, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.setCloudConfigLastUpdated = function(value) {
  return jspb.Message.setProto3IntField(this, 40, value);
};


/**
 * optional string run_id = 42;
 * @return {string}
 */
proto.flight_deck.Status.prototype.getRunId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 42, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.setRunId = function(value) {
  return jspb.Message.setProto3StringField(this, 42, value);
};


/**
 * optional string boot_id = 43;
 * @return {string}
 */
proto.flight_deck.Status.prototype.getBootId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 43, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.setBootId = function(value) {
  return jspb.Message.setProto3StringField(this, 43, value);
};


/**
 * optional WifiStatus wifi_status = 44;
 * @return {?proto.flight_deck.WifiStatus}
 */
proto.flight_deck.Status.prototype.getWifiStatus = function() {
  return /** @type{?proto.flight_deck.WifiStatus} */ (
    jspb.Message.getWrapperField(this, proto.flight_deck.WifiStatus, 44));
};


/**
 * @param {?proto.flight_deck.WifiStatus|undefined} value
 * @return {!proto.flight_deck.Status} returns this
*/
proto.flight_deck.Status.prototype.setWifiStatus = function(value) {
  return jspb.Message.setWrapperField(this, 44, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.clearWifiStatus = function() {
  return this.setWifiStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.Status.prototype.hasWifiStatus = function() {
  return jspb.Message.getField(this, 44) != null;
};


/**
 * optional bool rid_bcast = 47;
 * @return {boolean}
 */
proto.flight_deck.Status.prototype.getRidBcast = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 47, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.Status} returns this
 */
proto.flight_deck.Status.prototype.setRidBcast = function(value) {
  return jspb.Message.setProto3BooleanField(this, 47, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.UserCameraStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.UserCameraStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.UserCameraStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.UserCameraStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
mode: jspb.Message.getFieldWithDefault(msg, 1, 0),
recordingMode: jspb.Message.getFieldWithDefault(msg, 5, 0),
recordingBytesTotal: jspb.Message.getFieldWithDefault(msg, 2, 0),
recordingBytesRemaining: jspb.Message.getFieldWithDefault(msg, 3, 0),
recordingSecondsRemaining: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.UserCameraStatus}
 */
proto.flight_deck.UserCameraStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.UserCameraStatus;
  return proto.flight_deck.UserCameraStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.UserCameraStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.UserCameraStatus}
 */
proto.flight_deck.UserCameraStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.user_camera.UserCameraMode.Enum} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 5:
      var value = /** @type {!proto.user_camera.RecordingMode.Enum} */ (reader.readEnum());
      msg.setRecordingMode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setRecordingBytesTotal(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setRecordingBytesRemaining(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRecordingSecondsRemaining(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.UserCameraStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.UserCameraStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.UserCameraStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.UserCameraStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getRecordingMode();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getRecordingBytesTotal();
  if (f !== 0) {
    writer.writeSint64(
      2,
      f
    );
  }
  f = message.getRecordingBytesRemaining();
  if (f !== 0) {
    writer.writeSint64(
      3,
      f
    );
  }
  f = message.getRecordingSecondsRemaining();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
};


/**
 * optional user_camera.UserCameraMode.Enum mode = 1;
 * @return {!proto.user_camera.UserCameraMode.Enum}
 */
proto.flight_deck.UserCameraStatus.prototype.getMode = function() {
  return /** @type {!proto.user_camera.UserCameraMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.user_camera.UserCameraMode.Enum} value
 * @return {!proto.flight_deck.UserCameraStatus} returns this
 */
proto.flight_deck.UserCameraStatus.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional user_camera.RecordingMode.Enum recording_mode = 5;
 * @return {!proto.user_camera.RecordingMode.Enum}
 */
proto.flight_deck.UserCameraStatus.prototype.getRecordingMode = function() {
  return /** @type {!proto.user_camera.RecordingMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.user_camera.RecordingMode.Enum} value
 * @return {!proto.flight_deck.UserCameraStatus} returns this
 */
proto.flight_deck.UserCameraStatus.prototype.setRecordingMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional sint64 recording_bytes_total = 2;
 * @return {number}
 */
proto.flight_deck.UserCameraStatus.prototype.getRecordingBytesTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.UserCameraStatus} returns this
 */
proto.flight_deck.UserCameraStatus.prototype.setRecordingBytesTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional sint64 recording_bytes_remaining = 3;
 * @return {number}
 */
proto.flight_deck.UserCameraStatus.prototype.getRecordingBytesRemaining = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.UserCameraStatus} returns this
 */
proto.flight_deck.UserCameraStatus.prototype.setRecordingBytesRemaining = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double recording_seconds_remaining = 4;
 * @return {number}
 */
proto.flight_deck.UserCameraStatus.prototype.getRecordingSecondsRemaining = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.UserCameraStatus} returns this
 */
proto.flight_deck.UserCameraStatus.prototype.setRecordingSecondsRemaining = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.WiredStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.WiredStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.WiredStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.WiredStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
usbcConnected: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
batteryCradleConnected: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.WiredStatus}
 */
proto.flight_deck.WiredStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.WiredStatus;
  return proto.flight_deck.WiredStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.WiredStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.WiredStatus}
 */
proto.flight_deck.WiredStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUsbcConnected(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBatteryCradleConnected(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.WiredStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.WiredStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.WiredStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.WiredStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsbcConnected();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getBatteryCradleConnected();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional bool usbc_connected = 1;
 * @return {boolean}
 */
proto.flight_deck.WiredStatus.prototype.getUsbcConnected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.WiredStatus} returns this
 */
proto.flight_deck.WiredStatus.prototype.setUsbcConnected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool battery_cradle_connected = 2;
 * @return {boolean}
 */
proto.flight_deck.WiredStatus.prototype.getBatteryCradleConnected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.WiredStatus} returns this
 */
proto.flight_deck.WiredStatus.prototype.setBatteryCradleConnected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.Config.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.Config.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.Config} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.Config.toObject = function(includeInstance, msg) {
  var f, obj = {
startupUtime: jspb.Message.getFieldWithDefault(msg, 1, 0),
vehicleParams: (f = msg.getVehicleParams()) && pbtypes_gen_vehicle_params_for_phone_vehicle_params_pb.VehicleParams.toObject(includeInstance, f),
channelHashesMap: (f = msg.getChannelHashesMap()) ? f.toObject(includeInstance, undefined) : [],
deployInfo: (f = msg.getDeployInfo()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
rootfsVersion: (f = msg.getRootfsVersion()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
fpinfo: (f = msg.getFpinfo()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
skybusTunnelUdpHostname: jspb.Message.getFieldWithDefault(msg, 31, ""),
skybusTunnelUdpPort: jspb.Message.getFieldWithDefault(msg, 21, 0),
useWebSocketProxy: jspb.Message.getBooleanFieldWithDefault(msg, 32, false),
systemArch: jspb.Message.getFieldWithDefault(msg, 25, ""),
releaseKey: jspb.Message.getFieldWithDefault(msg, 26, ""),
diffBaseKeyDeprecated: jspb.Message.getFieldWithDefault(msg, 28, ""),
otaRelatedMetadata: jspb.Message.getFieldWithDefault(msg, 30, ""),
userType: jspb.Message.getFieldWithDefault(msg, 29, ""),
isSecondaryFlightDeck: jspb.Message.getBooleanFieldWithDefault(msg, 33, false),
socRole: jspb.Message.getFieldWithDefault(msg, 34, ""),
flashpackBuildType: jspb.Message.getFieldWithDefault(msg, 35, ""),
useDevLogging: jspb.Message.getBooleanFieldWithDefault(msg, 36, false),
shouldRunLogCleaner: jspb.Message.getBooleanFieldWithDefault(msg, 37, false),
fpReleaseKey: jspb.Message.getFieldWithDefault(msg, 38, ""),
fpGitCommit: jspb.Message.getFieldWithDefault(msg, 39, ""),
fpGitCommitDate: jspb.Message.getFieldWithDefault(msg, 40, ""),
fpGitTag: jspb.Message.getFieldWithDefault(msg, 41, ""),
fpGitBranch: jspb.Message.getFieldWithDefault(msg, 42, ""),
deployGitCommit: jspb.Message.getFieldWithDefault(msg, 43, ""),
deployGitCommitDate: jspb.Message.getFieldWithDefault(msg, 44, ""),
deployGitTag: jspb.Message.getFieldWithDefault(msg, 45, ""),
deployGitBranch: jspb.Message.getFieldWithDefault(msg, 46, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.Config}
 */
proto.flight_deck.Config.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.Config;
  return proto.flight_deck.Config.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.Config} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.Config}
 */
proto.flight_deck.Config.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartupUtime(value);
      break;
    case 2:
      var value = new pbtypes_gen_vehicle_params_for_phone_vehicle_params_pb.VehicleParams;
      reader.readMessage(value,pbtypes_gen_vehicle_params_for_phone_vehicle_params_pb.VehicleParams.deserializeBinaryFromReader);
      msg.setVehicleParams(value);
      break;
    case 16:
      var value = msg.getChannelHashesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readUint64, null, "", 0);
         });
      break;
    case 22:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setDeployInfo(value);
      break;
    case 23:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setRootfsVersion(value);
      break;
    case 24:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setFpinfo(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setSkybusTunnelUdpHostname(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSkybusTunnelUdpPort(value);
      break;
    case 32:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseWebSocketProxy(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setSystemArch(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setReleaseKey(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiffBaseKeyDeprecated(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setOtaRelatedMetadata(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserType(value);
      break;
    case 33:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSecondaryFlightDeck(value);
      break;
    case 34:
      var value = /** @type {string} */ (reader.readString());
      msg.setSocRole(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setFlashpackBuildType(value);
      break;
    case 36:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseDevLogging(value);
      break;
    case 37:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShouldRunLogCleaner(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setFpReleaseKey(value);
      break;
    case 39:
      var value = /** @type {string} */ (reader.readString());
      msg.setFpGitCommit(value);
      break;
    case 40:
      var value = /** @type {string} */ (reader.readString());
      msg.setFpGitCommitDate(value);
      break;
    case 41:
      var value = /** @type {string} */ (reader.readString());
      msg.setFpGitTag(value);
      break;
    case 42:
      var value = /** @type {string} */ (reader.readString());
      msg.setFpGitBranch(value);
      break;
    case 43:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeployGitCommit(value);
      break;
    case 44:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeployGitCommitDate(value);
      break;
    case 45:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeployGitTag(value);
      break;
    case 46:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeployGitBranch(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.Config.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.Config.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.Config} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.Config.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartupUtime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getVehicleParams();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_vehicle_params_for_phone_vehicle_params_pb.VehicleParams.serializeBinaryToWriter
    );
  }
  f = message.getChannelHashesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(16, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeUint64);
  }
  f = message.getDeployInfo();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getRootfsVersion();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getFpinfo();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getSkybusTunnelUdpHostname();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getSkybusTunnelUdpPort();
  if (f !== 0) {
    writer.writeInt32(
      21,
      f
    );
  }
  f = message.getUseWebSocketProxy();
  if (f) {
    writer.writeBool(
      32,
      f
    );
  }
  f = message.getSystemArch();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getReleaseKey();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getDiffBaseKeyDeprecated();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getOtaRelatedMetadata();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getUserType();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getIsSecondaryFlightDeck();
  if (f) {
    writer.writeBool(
      33,
      f
    );
  }
  f = message.getSocRole();
  if (f.length > 0) {
    writer.writeString(
      34,
      f
    );
  }
  f = message.getFlashpackBuildType();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getUseDevLogging();
  if (f) {
    writer.writeBool(
      36,
      f
    );
  }
  f = message.getShouldRunLogCleaner();
  if (f) {
    writer.writeBool(
      37,
      f
    );
  }
  f = message.getFpReleaseKey();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = message.getFpGitCommit();
  if (f.length > 0) {
    writer.writeString(
      39,
      f
    );
  }
  f = message.getFpGitCommitDate();
  if (f.length > 0) {
    writer.writeString(
      40,
      f
    );
  }
  f = message.getFpGitTag();
  if (f.length > 0) {
    writer.writeString(
      41,
      f
    );
  }
  f = message.getFpGitBranch();
  if (f.length > 0) {
    writer.writeString(
      42,
      f
    );
  }
  f = message.getDeployGitCommit();
  if (f.length > 0) {
    writer.writeString(
      43,
      f
    );
  }
  f = message.getDeployGitCommitDate();
  if (f.length > 0) {
    writer.writeString(
      44,
      f
    );
  }
  f = message.getDeployGitTag();
  if (f.length > 0) {
    writer.writeString(
      45,
      f
    );
  }
  f = message.getDeployGitBranch();
  if (f.length > 0) {
    writer.writeString(
      46,
      f
    );
  }
};


/**
 * optional int64 startup_utime = 1;
 * @return {number}
 */
proto.flight_deck.Config.prototype.getStartupUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.setStartupUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional vehicle_params_for_phone.VehicleParams vehicle_params = 2;
 * @return {?proto.vehicle_params_for_phone.VehicleParams}
 */
proto.flight_deck.Config.prototype.getVehicleParams = function() {
  return /** @type{?proto.vehicle_params_for_phone.VehicleParams} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_vehicle_params_for_phone_vehicle_params_pb.VehicleParams, 2));
};


/**
 * @param {?proto.vehicle_params_for_phone.VehicleParams|undefined} value
 * @return {!proto.flight_deck.Config} returns this
*/
proto.flight_deck.Config.prototype.setVehicleParams = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.clearVehicleParams = function() {
  return this.setVehicleParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.Config.prototype.hasVehicleParams = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * map<string, uint64> channel_hashes = 16;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.flight_deck.Config.prototype.getChannelHashesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 16, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.clearChannelHashesMap = function() {
  this.getChannelHashesMap().clear();
  return this;
};


/**
 * optional google.protobuf.Struct deploy_info = 22;
 * @return {?proto.google.protobuf.Struct}
 */
proto.flight_deck.Config.prototype.getDeployInfo = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 22));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.flight_deck.Config} returns this
*/
proto.flight_deck.Config.prototype.setDeployInfo = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.clearDeployInfo = function() {
  return this.setDeployInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.Config.prototype.hasDeployInfo = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional google.protobuf.Struct rootfs_version = 23;
 * @return {?proto.google.protobuf.Struct}
 */
proto.flight_deck.Config.prototype.getRootfsVersion = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 23));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.flight_deck.Config} returns this
*/
proto.flight_deck.Config.prototype.setRootfsVersion = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.clearRootfsVersion = function() {
  return this.setRootfsVersion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.Config.prototype.hasRootfsVersion = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional google.protobuf.Struct fpinfo = 24;
 * @return {?proto.google.protobuf.Struct}
 */
proto.flight_deck.Config.prototype.getFpinfo = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 24));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.flight_deck.Config} returns this
*/
proto.flight_deck.Config.prototype.setFpinfo = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.clearFpinfo = function() {
  return this.setFpinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flight_deck.Config.prototype.hasFpinfo = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional string skybus_tunnel_udp_hostname = 31;
 * @return {string}
 */
proto.flight_deck.Config.prototype.getSkybusTunnelUdpHostname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.setSkybusTunnelUdpHostname = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional int32 skybus_tunnel_udp_port = 21;
 * @return {number}
 */
proto.flight_deck.Config.prototype.getSkybusTunnelUdpPort = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.setSkybusTunnelUdpPort = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional bool use_web_socket_proxy = 32;
 * @return {boolean}
 */
proto.flight_deck.Config.prototype.getUseWebSocketProxy = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 32, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.setUseWebSocketProxy = function(value) {
  return jspb.Message.setProto3BooleanField(this, 32, value);
};


/**
 * optional string system_arch = 25;
 * @return {string}
 */
proto.flight_deck.Config.prototype.getSystemArch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.setSystemArch = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string release_key = 26;
 * @return {string}
 */
proto.flight_deck.Config.prototype.getReleaseKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.setReleaseKey = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string diff_base_key__deprecated = 28;
 * @return {string}
 */
proto.flight_deck.Config.prototype.getDiffBaseKeyDeprecated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.setDiffBaseKeyDeprecated = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string ota_related_metadata = 30;
 * @return {string}
 */
proto.flight_deck.Config.prototype.getOtaRelatedMetadata = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.setOtaRelatedMetadata = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string user_type = 29;
 * @return {string}
 */
proto.flight_deck.Config.prototype.getUserType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.setUserType = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional bool is_secondary_flight_deck = 33;
 * @return {boolean}
 */
proto.flight_deck.Config.prototype.getIsSecondaryFlightDeck = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 33, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.setIsSecondaryFlightDeck = function(value) {
  return jspb.Message.setProto3BooleanField(this, 33, value);
};


/**
 * optional string soc_role = 34;
 * @return {string}
 */
proto.flight_deck.Config.prototype.getSocRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.setSocRole = function(value) {
  return jspb.Message.setProto3StringField(this, 34, value);
};


/**
 * optional string flashpack_build_type = 35;
 * @return {string}
 */
proto.flight_deck.Config.prototype.getFlashpackBuildType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.setFlashpackBuildType = function(value) {
  return jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional bool use_dev_logging = 36;
 * @return {boolean}
 */
proto.flight_deck.Config.prototype.getUseDevLogging = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 36, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.setUseDevLogging = function(value) {
  return jspb.Message.setProto3BooleanField(this, 36, value);
};


/**
 * optional bool should_run_log_cleaner = 37;
 * @return {boolean}
 */
proto.flight_deck.Config.prototype.getShouldRunLogCleaner = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 37, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.setShouldRunLogCleaner = function(value) {
  return jspb.Message.setProto3BooleanField(this, 37, value);
};


/**
 * optional string fp_release_key = 38;
 * @return {string}
 */
proto.flight_deck.Config.prototype.getFpReleaseKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.setFpReleaseKey = function(value) {
  return jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * optional string fp_git_commit = 39;
 * @return {string}
 */
proto.flight_deck.Config.prototype.getFpGitCommit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.setFpGitCommit = function(value) {
  return jspb.Message.setProto3StringField(this, 39, value);
};


/**
 * optional string fp_git_commit_date = 40;
 * @return {string}
 */
proto.flight_deck.Config.prototype.getFpGitCommitDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.setFpGitCommitDate = function(value) {
  return jspb.Message.setProto3StringField(this, 40, value);
};


/**
 * optional string fp_git_tag = 41;
 * @return {string}
 */
proto.flight_deck.Config.prototype.getFpGitTag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 41, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.setFpGitTag = function(value) {
  return jspb.Message.setProto3StringField(this, 41, value);
};


/**
 * optional string fp_git_branch = 42;
 * @return {string}
 */
proto.flight_deck.Config.prototype.getFpGitBranch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 42, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.setFpGitBranch = function(value) {
  return jspb.Message.setProto3StringField(this, 42, value);
};


/**
 * optional string deploy_git_commit = 43;
 * @return {string}
 */
proto.flight_deck.Config.prototype.getDeployGitCommit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 43, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.setDeployGitCommit = function(value) {
  return jspb.Message.setProto3StringField(this, 43, value);
};


/**
 * optional string deploy_git_commit_date = 44;
 * @return {string}
 */
proto.flight_deck.Config.prototype.getDeployGitCommitDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 44, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.setDeployGitCommitDate = function(value) {
  return jspb.Message.setProto3StringField(this, 44, value);
};


/**
 * optional string deploy_git_tag = 45;
 * @return {string}
 */
proto.flight_deck.Config.prototype.getDeployGitTag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 45, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.setDeployGitTag = function(value) {
  return jspb.Message.setProto3StringField(this, 45, value);
};


/**
 * optional string deploy_git_branch = 46;
 * @return {string}
 */
proto.flight_deck.Config.prototype.getDeployGitBranch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 46, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_deck.Config} returns this
 */
proto.flight_deck.Config.prototype.setDeployGitBranch = function(value) {
  return jspb.Message.setProto3StringField(this, 46, value);
};


goog.object.extend(exports, proto.flight_deck);
